// @ts-nocheck
import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { getApiCall } from '@/service/httpCall';
import { API_AGENT_ACTIVITY_LOG_LIST } from '@/service/url';
import Loader from '@/components/partials/components/Loader';
import ActivityTimeline from './ActivityTimeline';

export default function SessionActivityTimeline({ logId }: any) {
  const [events, setEvents] = useState(null);

  useEffect(() => {
    if (!logId) return undefined;
    let cancelled = false;
    setEvents(null);
    getApiCall(`${API_AGENT_ACTIVITY_LOG_LIST}?id=${encodeURIComponent(logId)}&limit=1`, {})
      .then((resp) => {
        if (!cancelled) setEvents(resp?.rows?.[0]?.activity || []);
      })
      .catch((e) => {
        if (cancelled) return;
        toast.error(typeof e === 'string' ? e : 'Failed to load activity');
        setEvents([]);
      });
    return () => {
      cancelled = true;
    };
  }, [logId]);

  if (events === null) return <Loader />;
  return <ActivityTimeline events={events} />;
}
